import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';

export default class DiscussionLockedNotification extends Notification {
  icon() {
    return '';
  }

  img() {
    return `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/img-sd.png`;
  }

  href() {
    const notification = this.attrs.notification;

    return app.route.discussion(notification.subject(), notification.content().postNumber);
  }

  content() {
    if (this.attrs.notification.content().islocked) {
      return app.translator.trans('flarum-lock.forum.notifications.discussion_locked_text', { username: this.attrs.notification.fromUser().nickname() });
    }
    return app.translator.trans('dl-response.forum.notifications.discussion_unlocked_text', { username: this.attrs.notification.fromUser().nickname() });
  }
}
